
export class ItemAttribute {
    id:number|undefined;
    value:string ="";
    value2:string ="";
    type:string ="";
    src:string ="";
    label:string ="";
    description: string = '';
    class_style:string ="";
    width:string ="100%";
    widthClass:string ="col-12";

}
